import React, { useEffect, useState } from 'react'
import { TextField as MuiTextField, MenuItem } from '@mui/material'
import useSchemaTests from '../hooks/useSchemaTests'

export const Select = props => {
    const {
        name,
        label,
        required,
        selected,
        error,
        helperText,
        options,
        showEmptyOption,
        emptyOptionLabel,
        watchValue,
        schema,
        formErrors,
        inputRef,
        setFormValue,
        onChange,
        readOnly,
        InputProps,
        defaultValue,
        ...rest
    } = props
    const emptyOption = { id: "", label: emptyOptionLabel ?? <div>{'\u00A0'}</div> }

    const [value, setValue] = useState('')
    const [renderOptions, setRenderOptions] = useState('')

    const [schemaRequired] = useSchemaTests(schema)

    const IProps = {
        ...InputProps,
        ...(readOnly && { readOnly: true })
    }

    useEffect(() => {
        setFormValue(name, value)

        if (onChange)
            onChange(value)
    }, [value, name, setFormValue, onChange])

    useEffect(() => {
        if (watchValue)
            setValue(watchValue)
    }, [watchValue])

    useEffect(() => {
        if (!options || readOnly)
            return

        const o = showEmptyOption ? [emptyOption, ...options] : options
        const def = defaultValue ? o.find((i) => i.addressCode === defaultValue) : o[0]
        setRenderOptions(
            o.map((i, index) => (
                <MenuItem key={`${i.addressCode}-${index}`} value={i.addressCode}>
                    {i.addressCode}
                </MenuItem>
            ))
        )
        setValue(selected ?? def?.addressCode)
    }, [options, selected, readOnly])

    return (
        <MuiTextField
            select={(readOnly || !renderOptions) ? undefined : true}
            value={value}
            label={label || schema.label}
            InputProps={IProps}
            InputLabelProps={{ required: required !== undefined ? required : !!schemaRequired }}
            error={error !== undefined ? error : !!formErrors}
            helperText={helperText || formErrors?.message}
            onChange={e => setValue(e.target.value)}
            //displayEmpty
            {...rest}
        >
            {renderOptions}
        </MuiTextField >
    )
}
